export default "__VITE_ASSET__Dh92lq8t__"